import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

var _defineProperty2;

import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context4; _forEachInstanceProperty(_context4 = ownKeys(Object(source), true)).call(_context4, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context5; _forEachInstanceProperty(_context5 = ownKeys(Object(source))).call(_context5, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _ from 'lodash';
import { ITEMS, STATUS, ERROR } from '@rexlabs/entity-normalizer';
import createModel from '../utils/models';
import { getActionCreators as _getActionCreators } from '../actions/value-lists';
export var VALUE_LISTS = 'valueLists';
/**
 * Redux Value List Model, that handles dealing with value lists coming from
 * an API
 * @param {Object}
 * @constructor
 */

var ValueListModel = /*#__PURE__*/function () {
  function ValueListModel(_ref) {
    var modelName = _ref.modelName,
        _ref$actionCreators = _ref.actionCreators,
        actionCreators = _ref$actionCreators === void 0 ? {} : _ref$actionCreators,
        _ref$selectors = _ref.selectors,
        selectors = _ref$selectors === void 0 ? {} : _ref$selectors,
        _ref$initialState = _ref.initialState,
        initialState = _ref$initialState === void 0 ? {} : _ref$initialState,
        _ref$config = _ref.config,
        config = _ref$config === void 0 ? {} : _ref$config;

    _classCallCheck(this, ValueListModel);

    var vlActionCreators = this.getActionCreators(modelName, config, actionCreators);
    var vlSelectors = this.getSelectors(modelName, selectors);

    var vlState = _.merge({}, ValueListModel.initialState, initialState);

    var model = createModel({
      modelName: modelName,
      actionCreators: vlActionCreators,
      selectors: vlSelectors,
      initialState: vlState,
      config: config
    });
    model.__valueListModel = true;
    return model;
  }

  _createClass(ValueListModel, [{
    key: "getActionCreators",
    value: function getActionCreators(modelName, config, customActionCreators) {
      return _objectSpread(_objectSpread({}, _getActionCreators(modelName, config)), customActionCreators);
    }
  }, {
    key: "getSelectors",
    value: function getSelectors(modelName) {
      var _ref2;

      return _ref2 = {}, _defineProperty(_ref2, ITEMS, function (state) {
        var _context;

        return _.get(state, _concatInstanceProperty(_context = "".concat(VALUE_LISTS, ".").concat(modelName, ".")).call(_context, ITEMS), []);
      }), _defineProperty(_ref2, STATUS, function (state) {
        var _context2;

        return _.get(state, _concatInstanceProperty(_context2 = "".concat(VALUE_LISTS, ".").concat(modelName, ".")).call(_context2, STATUS), null);
      }), _defineProperty(_ref2, ERROR, function (state) {
        var _context3;

        return _.get(state, _concatInstanceProperty(_context3 = "".concat(VALUE_LISTS, ".").concat(modelName, ".")).call(_context3, ERROR));
      }), _ref2;
    }
  }]);

  return ValueListModel;
}();

_defineProperty(ValueListModel, "initialState", (_defineProperty2 = {}, _defineProperty(_defineProperty2, ITEMS, []), _defineProperty(_defineProperty2, STATUS, null), _defineProperty(_defineProperty2, ERROR, null), _defineProperty2));

export { ValueListModel as default };